<template>
  <validation-observer ref="tabIv">
    <custom-collapse class="mt-2" :id="'tab-' + skill.id">
      <custom-collapse-item
        :title="skill.name"
        :parentId="'tab-' + skill.id"
        :expanded="skill.expanded"
        :checked="skill.checked"
        :selected="skill.selected"
        :disabled="isReadOnly"
        :buttonIcon="'far fa-times-circle color-red'"
        :expanded-icon="'fas fa-plus-circle color-black--3'"
        @actionButtonClick="onDeleteClicked"
        @expandButtonClick="expandButtonClicked"
      >
        <div class="row pt-4">
          <div class="col col-spacing student-spacing">
            <div class="color-secondary-6 font-14 font-weight-normal">
              Entre sus intereses el estudiante manifiesta:
            </div>
            <div class="color-black font-16 mt-2 font-weight-bold">
              <validation-provider
                mode="eager"
                :rules="'required'"
                v-slot="{ errors }"
              >
                <custom-text-area
                  :disabled="isReadOnly"
                  v-model="value.interests"
                  placeholder="Comentario"
                  custom-error-msg="Favor escribir el comentario."
                  :error="errors[0] ? 'err' : ''"
                  :maxlength="100000"
                />
              </validation-provider>
            </div>
          </div>
        </div>
      </custom-collapse-item>
    </custom-collapse>
  </validation-observer>
</template>
<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import ActionButton from 'ActionButton';
import CustomInput from 'CustomInput';
import CustomCollapse from '@/components/common/CustomCollapse';
import CustomCollapseItem from '@/components/common/CustomCollapseItem';
import mixAlert from '@/mixins/alert.mixin';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import CustomTextArea from '@quisit/custom-text-area';
import fileUtils from '@/utils/utilities';

export default {
  name: 'TabIWorkSkills',
  components: {
    SectionTitle,
    CustomDropDown,
    ActionButton,
    CustomCollapse,
    CustomCollapseItem,
    ValidationObserver,
    ValidationProvider,
    CustomInput,
    CustomTextArea,
  },
  mixins: [mixAlert],
  props: {
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    skill: {
      type: Object,
      default: {},
    },
    atServiceId: {
      type: Number,
      default: null,
    },
    value: {
      type: Object,
      default: () => ({
        interests: null,
      }),
    },
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    async onDeleteClicked() {
      const isConfirmed = !fileUtils.isEmpty(this.value)
        ? await this.ShowCancelModal(
            'Confirmación',
            `¿Está seguro que desea remover el panel de ${this.skill.name}, se eliminarán los datos suministrados hasta ahora?`,
            'Sí',
            'No'
          )
        : true;

      if (!isConfirmed) {
        return;
      }

      this.value.interests = null;

      this.$emit('delete', { skill: this.skill, questionnaire: [] });
    },
    expandButtonClicked() {
      this.skill.expanded = !this.skill.expanded;
    },
  },
};
</script>
